import React from 'react'
import PageTitleAndSnackBar from '../../components/common/PageTitleAndSnackBar'
import SupplierList from '../../components/supplier/SupplierList'
import SupplierTicket from '../../components/supplier/SupplierTicket'
import SupplierLedger from '../../components/supplier/SupplierLedger'
import { useParams } from 'react-router-dom'
import { capitalizeFirstLetter, titleCase } from '../../helper/stringMethods'

const Supplier = () => {
    let { method } = useParams();

    return (
        <>
            <PageTitleAndSnackBar pageTitle={"Supplier " + capitalizeFirstLetter(method)} />
            {
                method === "list" && <SupplierList />
            }
            {
                method === "ticketlist" && <SupplierTicket />
            }
            {
                method === "ledger" && <SupplierLedger />

            }

        </>
    )
}

export default Supplier